export enum SignInSteps {
	login = 'login',
	registration = 'registration'
}
